<template>
  <base-dialog
    v-model="localValue"
    :show-footer="true"
    :persistent="true"
    :hide-close-button="true"
    :loading="loading"
    cancel-label="Cancel"
    confirm-label="Unsubscribe"
    confirm-button-class="base-dialog__negative-btn"
    @cancel="$emit('cancel')"
    @confirm="$emit('confirm')"
  >
    <div>
      <p class="q-mb-md">
        Cancel your subscription to the <strong>{{ plan.name }} Plan</strong>?
      </p>

      <div class="warning-info q-pa-md q-mb-md">
        <div class="row items-center">
          <q-icon name="info" size="20px" color="warning" class="q-mr-sm" />
          <span class="warning-info__text">You will retain access until your current billing period ends.</span>
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'UnsubscribeConfirmDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    plan: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-info {
  background-color: rgba(var(--warning-rgb), 0.1);
  border-radius: 8px;
  border-left: 4px solid var(--warning);

  &__text {
    @include inter-font($size: 14px, $bolded: true, $color: var(--main-text-color));
  }
}

/* Custom styles already handled by base-dialog__negative-btn */
</style>
